import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LocationSwitcher from './LocationSwitcher';

const navItems = [
  { path: '/staff', label: 'Dashboard', end: true },
  { path: '/staff/schedule', label: 'My Schedule' },
  { path: '/staff/commissions', label: 'Earnings' },
  { path: '/staff/clients', label: 'Client Lookup' },
];

export default function StaffLayout() {
  const { user, logout, isManager, isSuperAdmin, canClient } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();
  const doLogout = () => { logout(); navigate('/login'); };
  const initials = (user?.firstName?.[0] || '') + (user?.lastName?.[0] || '');
  const isActive = (path, end) => end ? loc.pathname === path : loc.pathname.startsWith(path);

  return (
    <>
      <div className="mobile-header" style={{ background: 'linear-gradient(90deg, #22695c, #1a5247)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div className="hamburger" onClick={() => setOpen(!open)} style={{ color: '#fff' }}><span /><span /><span /></div>
          <span style={{ fontFamily: 'var(--rr-font-heading)', fontSize: 17, color: '#fff' }}>Staff Portal</span>
        </div>
      </div>
      <div className={`sidebar-overlay ${open ? 'open' : ''}`} onClick={() => setOpen(false)} />
      <div className="app-container">
        <aside className={`app-sidebar ${open ? 'open' : ''}`} style={{ background: 'linear-gradient(170deg, #22695c 0%, #1a5247 100%)', color: '#fff', padding: '30px 0 24px' }}>
          <div style={{ padding: '0 28px 26px', borderBottom: '1px solid rgba(255,255,255,.12)' }}>
            <div style={{ fontFamily: 'var(--rr-font-heading)', fontSize: 25, lineHeight: 1.15 }}>Royal<br />Revitalization</div>
            <div style={{ marginTop: 12, fontSize: 10.5, fontWeight: 700, letterSpacing: '.22em', color: '#d9bd7f' }}>STAFF PORTAL</div>
          </div>

          <nav style={{ display: 'flex', flexDirection: 'column', gap: 4, padding: '20px 16px 0', flex: 1 }}>
            <LocationSwitcher portalRoles={['staff','manager','franchise_owner']} />
            {navItems.map(item => {
              const active = isActive(item.path, item.end);
              return (
                <NavLink key={item.path} to={item.path} end={item.end} onClick={() => setOpen(false)}
                  style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '11px 14px', borderRadius: 10, color: active ? '#fff' : 'rgba(255,255,255,.65)', background: active ? 'rgba(255,255,255,.14)' : 'transparent', textDecoration: 'none', fontSize: 14, fontWeight: active ? 600 : 500, transition: 'all .14s' }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'currentColor', opacity: .75 }} />
                  {item.label}
                </NavLink>
              );
            })}
          </nav>

          <div style={{ marginTop: 'auto', padding: '16px 22px 0', borderTop: '1px solid rgba(255,255,255,.12)', display: 'flex', flexDirection: 'column', gap: 6 }}>
            <div style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '.14em', color: 'rgba(255,255,255,.35)', marginBottom: 4 }}>SWITCH PORTAL</div>
            {isSuperAdmin &&  <NavLink to="/admin" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Super Admin <span style={{ opacity:.5 }}>→</span></NavLink>}
            {isManager && <NavLink to="/manager" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Manager Portal <span style={{ opacity:.5 }}>→</span></NavLink>}
            {canClient &&  <NavLink to="/" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Client Portal <span style={{ opacity:.5 }}>→</span></NavLink>}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '16px 22px 0', borderTop: '1px solid rgba(255,255,255,.12)', marginTop: 14 }}>
            <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,.14)', border: '1px solid rgba(217,189,127,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--rr-font-heading)', fontSize: 15, color: '#e8d4a6' }}>{initials}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13.5, fontWeight: 600 }}>{user?.firstName} {user?.lastName}</div>
              <div style={{ fontSize: 11.5, color: 'rgba(255,255,255,.6)' }}>{user?.role?.replace('_', ' ')}</div>
            </div>
            <button onClick={doLogout} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.45)', cursor: 'pointer', fontSize: 11 }}>Out</button>
          </div>
        </aside>
        <main className="app-main" style={{ animation: 'rrFade .28s ease both' }}><Outlet /></main>
      </div>
    </>
  );
}
